import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { ApiService } from './api.service';
import { InvoiceData } from '../restaurant-manager.models';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService {

    constructor(
        private apiService: ApiService
    ) {}

    generate(restaurantId: string, data: InvoiceData): Observable<any> {
        return this.apiService.post<any>('/restaurants/' + restaurantId + '/invoice', data, true).pipe(map((result: any) => {
            return result;
        }));
    }

}
